<template>
  <div>
    <Head :title="`${form.fullname}`" />
    <div class="flex justify-start w-full mb-8 align-middle">
      <img v-if="biodata.photo" class="block w-32 h-32 ml-4 rounded-lg" :src="biodata.photo" />
      <h1 class="flex flex-col ml-4 text-2xl font-bold">
        <span>{{ form.fullname }}</span>
        <span class="text-xl">{{ form.nim }}</span>
      </h1>
    </div>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input
            v-model="form.nim" :error="form.errors.nim" class="w-full pb-8 pr-6 lg:w-4/12" label="NIM Mahasiswa"
            maxlength="25"
          />
          <text-input
            v-model="form.fullname" :error="form.errors.fullname || htmlErrors.fullname" class="w-full pb-8 pr-6 lg:w-8/12"
            label="Nama Lengkap Mahasiswa" maxlength="150"
          />
          <div v-if="htmlErrors.fullname" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-4/12">{{ htmlErrors.fullname }}</div>
          <text-input v-model="form.nik" label="NIK" :error="form.errors.nik || nikError" class="w-full pb-8 pr-6 lg:w-4/12" placeholder="NIK" type="text" autofocus autocapitalize="off" maxlength="16" />

          <text-input
            v-model="form.tempat_lahir" :error="form.errors.tempat_lahir || htmlErrors.tempat_lahir" class="w-full pb-8 pr-6 lg:w-4/12"
            label="Tempat Lahir" maxlength="50"
          />
          <div v-if="htmlErrors.tempat_lahir" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-4/12">{{ htmlErrors.tempat_lahir }}</div>

          <text-input
            v-model="form.tgl_lahir" v-mask="'####-##-##'" :error="form.errors.tgl_lahir"
            class="w-full pb-8 pr-6 lg:w-4/12" label="Tgl. Lahir" placeholder="yyyy-mm-dd"
          />
          <textarea-input
            v-model="form.alamat" :error="form.errors.alamat || htmlErrors.alamat" class="w-full pb-8 pr-6 lg:w-6/12" label="Alamat"
            maxlength="300"
          />
          <div v-if="htmlErrors.alamat" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-6/12">{{ htmlErrors.alamat }}</div>

          <textarea-input
            v-model="form.alamat_ktp" :error="form.errors.alamat_ktp || htmlErrors.alamat_ktp" class="w-full pb-8 pr-6 lg:w-6/12" label="Alamat KTP (isi jika beda dengan domisili sekarang)"
            maxlength="300"
          />
          <div v-if="htmlErrors.alamat_ktp" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-6/12">{{ htmlErrors.alamat_ktp }}</div>

          <div class="w-full pb-8 pr-6 lg:w-3/12">
            <label for="kecamatan" class="form-label">Kecamatan</label>
            <v-select
              v-model="form.kecamatan" :options="kecamatans" :reduce="kecamatan => kecamatan.id" label="nama"
              placeholder="Pilih Kecamatan"
              :class="{ 'border-red-500': form.errors.kecamatan }"
            />
            <div v-if="form.errors.kecamatan" class="mt-2 form-error">{{ form.errors.kecamatan }}</div>
          </div>
          <div class="w-full pb-8 pr-6 lg:w-3/12">
            <label for="kelurahan" class="form-label">Kelurahan</label>
            <v-select
              v-model="form.kelurahan" :options="kelurahans" :reduce="kelurahan => kelurahan.id" label="nama"
              placeholder="Pilih Kelurahan"
              :class="{ 'border-red-500': form.errors.kelurahan }"
            />
            <div v-if="form.errors.kelurahan" class="mt-2 form-error">{{ form.errors.kelurahan }}</div>
          </div>
          <text-input
            v-model="form.rw" :error="form.errors.rw" class="w-full pb-8 pr-6 lg:w-3/12" label="RW"
            maxlength="4" placeholder="RW"
          />
          <text-input
            v-model="form.rt" :error="form.errors.rt" class="w-full pb-8 pr-6 lg:w-3/12" label="RT"
            maxlength="4" placeholder="RT"
          />
          <select-input
            v-model="form.jenis_kelamin" :error="form.errors.jenis_kelamin" class="w-full pb-8 pr-6 lg:w-1/2"
            label="Jenis Kelamin"
          >
            <option value="Laki-laki">Laki-laki</option>
            <option value="Perempuan">Perempuan</option>
          </select-input>
          <select-input v-model="form.agama" :error="form.errors.agama" class="w-full pb-8 pr-6 lg:w-1/2" label="Agama">
            <option value="Islam">Islam</option>
            <option value="Kristen Protestan">Kristen Protestan</option>
            <option value="Kristen Katolik">Kristen Katolik</option>
            <option value="Hindu">Hindu</option>
            <option value="Buddha">Buddha</option>
            <option value="Konghucu">Konghucu</option>
          </select-input>
          <text-input
            v-model="form.nama_ayah" :error="form.errors.nama_ayah || htmlErrors.nama_ayah" class="w-full pb-8 pr-6 lg:w-6/12"
            label="Nama Ayah" maxlength="100"
          />
          <div v-if="htmlErrors.nama_ayah" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-6/12">{{ htmlErrors.nama_ayah }}</div>

          <text-input
            v-model="form.nama_ibu" :error="form.errors.nama_ibu || htmlErrors.nama_ibu" class="w-full pb-8 pr-6 lg:w-6/12"
            label="Nama Ibu" maxlength="100"
          />
          <div v-if="htmlErrors.nama_ibu" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-6/12">{{ htmlErrors.nama_ibu }}</div>

          <text-input
            v-model="form.telp" :error="form.errors.telp" class="w-full pb-8 pr-6 lg:w-1/2"
            label="Nomor Telepon" maxlength="15"
          />
          <div class="w-full pb-8 pr-6 lg:w-1/2">
            <label for="university" class="form-label">Universitas</label>
            <v-select
              v-model="form.university" :options="universities" :reduce="university => university.id" label="nama"
              placeholder="Pilih Universitas"
              :class="{ 'border-red-500': form.errors.university }"
            />
            <div v-if="form.errors.university" class="mt-2 form-error">{{ form.errors.university }}</div>
          </div>
          <div class="w-full pb-8 pr-6 lg:w-1/2">
            <label for="prodi" class="form-label">Prodi</label>
            <v-select
              v-model="form.prodi_id" :options="prodis" :reduce="prodi => prodi.id" label="nama"
              placeholder="Pilih Prodi"
              :class="{ 'border-red-500': form.errors.prodi_id }"
            />
            <div v-if="form.errors.prodi_id" class="mt-2 form-error">{{ form.errors.prodi_id }}</div>
          </div>
          <text-input
            v-model="form.sekolah_asal" :error="form.errors.sekolah_asal || htmlErrors.sekolah_asal" class="w-full pb-8 pr-6 lg:w-6/12"
            label="Nama Sekolah Asal" maxlength="100" placeholder="Misal: SMAN 1 Cilegon"
          />
          <div v-if="htmlErrors.sekolah_asal" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-6/12">{{ htmlErrors.sekolah_asal }}</div>

          <file-input
            v-model="form.photo" :error="form.errors.photo" class="w-full pb-8 pr-6 lg:w-1/2" type="file"
            accept="image/png, image/jpeg" label="Photo"
          />
          <div v-if="form.errors.photo" class="w-full px-6 -mt-6 -mb-2 form-error lg:w-1/2">{{ form.errors.photo }}</div>
          <select-input
            v-model="form.juare" :error="form.errors.juare" class="w-full pb-8 pr-6 lg:w-1/2"
            label="Program Beasiswa"
          >
            <option value="0">KCS</option>
            <option value="1">Juare</option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput.vue'
import SelectInput from '../../Shared/SelectInput.vue'
import { mask } from 'vue-the-mask'

export default {
  components: {
    FileInput,
    Head,
    LoadingButton,
    TextInput,
    TextareaInput,
    SelectInput,
  },
  directives: { mask },
  layout: Layout,
  props: {
    universities: Array,
    prodis: Array,
    kecamatans: Array,
    kelurahans: Array,
    biodata: Object,
    filters: Object,
  },
  remember: 'form',
  data() {
    return {
      nikError: '',
      htmlErrors: {
        fullname: '',
        tempat_lahir: '',
        alamat: '',
        alamat_ktp: '',
        nama_ayah: '',
        nama_ibu: '',
        sekolah_asal: '',
      },
      form: this.$inertia.form({
        _method: 'put',
        fullname: this.biodata.fullname,
        nim: this.biodata.nim,
        nik: this.biodata.nik,
        tempat_lahir: this.biodata.tempat_lahir,
        tgl_lahir: this.biodata.tgl_lahir == null ? new Date() : this.biodata.tgl_lahir,
        alamat: this.biodata.alamat,
        alamat_ktp: this.biodata.alamat_ktp,
        jenis_kelamin: this.biodata.jenis_kelamin,
        telp: this.biodata.telp,
        prodi_id: this.biodata.prodi_id,
        university: this.biodata.university,
        kelurahan: this.biodata.kelurahan,
        kecamatan: this.biodata.kecamatan,
        rw: this.biodata.rw,
        rt: this.biodata.rt,
        nama_ayah: this.biodata.nama_ayah,
        nama_ibu: this.biodata.nama_ibu,
        agama: this.biodata.agama,
        sekolah_asal: this.biodata.sekolah_asal,
        juare: this.biodata.juare,
        photo: null,
      }),
    }
  },
  watch: {
    'form.university'(value) {
      this.form.prodi_id = null
      this.$inertia.get('/biodata/edit', { university: value, kecamatan: this.form.kecamatan }, { preserveScroll: true, preserveState: true })
    },
    'form.kecamatan'(value) {
      this.form.kelurahan = null
      this.$inertia.get('/biodata/edit', { kecamatan: value, university: this.form.university }, { preserveScroll: true, preserveState: true })
    },
    'form.fullname'(newValue) {
      this.validateHtmlTag(newValue, 'fullname')
    },
    'form.tempat_lahir'(newValue) {
      this.validateHtmlTag(newValue, 'tempat_lahir')
    },
    'form.alamat'(newValue) {
      this.validateHtmlTag(newValue, 'alamat')
    },
    'form.alamat_ktp'(newValue) {
      this.validateHtmlTag(newValue, 'alamat_ktp')
    },
    'form.nama_ayah'(newValue) {
      this.validateHtmlTag(newValue, 'nama_ayah')
    },
    'form.nama_ibu'(newValue) {
      this.validateHtmlTag(newValue, 'nama_ibu')
    },
    'form.sekolah_asal'(newValue) {
      this.validateHtmlTag(newValue, 'sekolah_asal')
    },
    'form.nik': {
      handler(newValue) {
        this.validateNik(newValue)
      },
    },
  },
  methods: {
    validateNik(nik) {
      const nikRegex = /^\d{6}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/

      if (nik.length === 0) {
        this.nikError = ''
        return
      }

      if (nik.length !== 16) {
        this.nikError = 'NIK harus terdiri dari 16 digit angka.'
        return
      }

      if (!/^\d+$/.test(nik)) {
        this.nikError = 'NIK hanya boleh berisi angka.'
        return
      }

      if (!nikRegex.test(nik)) {
        this.nikError = 'Format NIK tidak valid.'
      } else {
        this.nikError = ''
      }
    },
    validateHtmlTag(value, fieldName) {
      const htmlTagRegex = /<[^>]+>/
      const htmlEntityRegex = /&lt;[a-zA-Z/][^&;]*&gt;/

      if (htmlTagRegex.test(value) || htmlEntityRegex.test(value)) {
        this.htmlErrors[fieldName] = 'Input tidak boleh mengandung tag HTML atau entitas HTML.'
        return false
      } else {
        this.htmlErrors[fieldName] = ''
        return true
      }
    },
    update() {
      this.form.clearErrors()

      let hasClientError = false

      const fieldsToValidate = ['fullname', 'tempat_lahir', 'alamat', 'alamat_ktp', 'nama_ayah', 'nama_ibu', 'sekolah_asal']
      for (const field of fieldsToValidate) {
        if (!this.validateHtmlTag(this.form[field], field)) {
          hasClientError = true
        }
      }

      if (this.form.errors.kecamatan || this.form.errors.kelurahan || this.form.errors.university || this.form.errors.prodi_id) {
        hasClientError = true
      }

      if (this.form.errors.photo) {
        hasClientError = true
      }

      if (hasClientError) {
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi Gagal',
          text: 'Mohon periksa kembali input Anda. Beberapa bidang mungkin tidak valid.',
        })
        return
      }

      this.form.post('/biodata/'+this.biodata.id)
    },
  },
}
</script>

<style scoped>
.form-error {
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.form-valid {
  color: #15803d;
  font-size: 0.875rem;
}
.v-select.border-red-500 .vs__dropdown-toggle {
    border-color: #ef4444 !important;
}
</style>
